import { Grid } from 'antd';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { IconSvg } from 'shared/icon';
import { useTimeZone } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { selectUserConfigTimeZone } from 'app/userPreferences/selectors';
import { useGetTimeZonesQuery } from 'app/timeZone/api';
import { useCreateOrEditUserConfigMutation } from 'app/userPreferences/api';
import type { DefaultOptionType } from 'antd/es/select';

import { Settings } from 'router/types';
import {
  StyledHeaderSelectClose, StyledHeaderSelectToggle, StyledHeaderSelectWrapper, StyledListItemViewMode,
} from 'app/layout/components/Layout.styled';
import { AdminSelect } from 'shared/formControl';

const { useBreakpoint } = Grid;

interface TimeZonesProps{
  timeZoneSettings?: Settings
}

const TimeZones = ({ timeZoneSettings }:TimeZonesProps) => {
  const [createOrEditUserConfig] = useCreateOrEditUserConfigMutation();

  const { data: timeZones } = useGetTimeZonesQuery();

  const [open, setOpen] = useState(false);

  const timeZone = useAppSelector(selectUserConfigTimeZone);

  const screens = useBreakpoint();
  const isSmallDevice = !screens.sm;
  const { setDateTz } = useTimeZone();

  const { colors } = useTheme();

  useEffect(() => {
    if (timeZones?.length && !timeZone) {
      const id = Intl.DateTimeFormat().resolvedOptions().timeZone;
      createOrEditUserConfig({ key: 'timeZone', configValue: id });
    }
  }, [timeZones, createOrEditUserConfig, timeZone]);

  useEffect(() => {
    if (timeZone) {
      setDateTz(timeZone);
    }
  }, [timeZone, setDateTz]);

  if (!timeZones?.length || !timeZone) {
    return;
  }

  if (!timeZoneSettings?.editMode) {
    const name = timeZones.find(({ id }) => id === timeZone)?.name || '';

    return <StyledListItemViewMode>{isSmallDevice ? name.slice(name.lastIndexOf(' ') + 1) : name}</StyledListItemViewMode>;
  }

  const openDropDown = () => {
    setOpen(true);
  };

  const closeDropDown = () => {
    setOpen(false);
  };

  const timeZoneChange = (id: string) => {
    createOrEditUserConfig({ key: 'timeZone', configValue: id });
    closeDropDown();
  };

  return (
    <div>
      <StyledHeaderSelectToggle onClick={openDropDown}>
        <IconSvg icon="TimeZoneIcon" width="1.41rem" height="1.41rem" color={colors.white} />
      </StyledHeaderSelectToggle>
      <StyledHeaderSelectWrapper $isOpen={open}>
        <AdminSelect
          onChange={timeZoneChange}
          value={timeZone}
          allowClear={false}
          showSearch={{
            filterOption: (input: string, option?: DefaultOptionType) => ((option?.children ?? '')?.toString() ?? '').toLowerCase().includes(input.toLowerCase()),
          }}
          data={timeZones}
          isToString={false}
          virtual={false}
        />
        <StyledHeaderSelectClose onClick={closeDropDown}>
          <IconSvg icon="CloseModalIcon" width="1.14rem" height="1.14rem" color={colors.white} />
        </StyledHeaderSelectClose>
      </StyledHeaderSelectWrapper>
    </div>
  );
};

export default TimeZones;
